<template>
    <div class="main-box">
        <div class="main-container">
            <el-row>
                <el-col :span="18" class="left-container" v-loading="loading" :offset="3">
                    <div class="container" v-if="!empty">
                        <div class="header">
                            <div class="title">
                                <span class="urgent" v-if="post.urgentFlag === 1">急</span>
                                {{post.postName}}
                                <div class="salary" v-if="[null, '', undefined].indexOf(post.minimalSalary) === -1 &&
                                    [null, '', undefined].indexOf(post.maximumSalary) === -1 && [null, '', undefined].indexOf(post.salaryMonth) === -1">
                                    {{(post.minimalSalary === 0 && post.maximumSalary === 0)?'':(post.minimalSalary + '-' + post.maximumSalary + 'K·' + post.salaryMonth + '薪')}}
                                </div>
                            </div>
                            <div class="status">
                                <span class="item" v-if="post.area" v-html="post.area.areaName"></span>
                                <span class="item" v-if="post.postType" v-html="post.postType.postTypeName"></span>
                                <span class="item" v-if="post.org" v-html="post.org.orgName"></span>
                            </div>
                            <el-button class="btn" type="primary" size="small" @click="imageShow = true">推荐岗位</el-button>
                        </div>
                        <div class="content">
                            <div class="title">
                                <span class="describe">职位描述</span>
                            </div>
                            <div class="duty" v-if="post.duty">工作职责：</div>
                            <div>
                                <p class="detailed" v-for="text of post.duty" :key="text" v-html="text"></p>
                            </div>
                            <div class="requirement" v-if="post.requirement">任职要求：</div>
                            <div>
                                <p class="detailed" v-for="text of post.requirement" :key="text" v-html="text"></p>
                            </div>
                        </div>
                        <div class="footer">
                            <el-button @click="imageShow = true" size="small" type="primary">推荐岗位</el-button>
                        </div>
                    </div>
                    <div class="container" v-if="empty">
                        <el-empty description="抱歉，该职位已停止招聘，去看看其他机会吧！">
                            <el-button type="primary" size="small" @click="otherPostClick">查看其他岗位</el-button>
                        </el-empty>
                    </div>
                </el-col>
            </el-row>
        </div>
        <QRCodeImage v-model="imageShow" :url="qrcodeUrl" />
    </div>
</template>
<script>
import api from '@/api';
import QRCodeImage from '@/components/QRCodeImage.vue';
export default {
    name: 'PostDetail',
    components: {
        QRCodeImage
    },
    data() {
        return {
            textareaText: '',
            loading: false,
            empty: false,
            post: {
                recruitmentFaceToType: 1,
                duty: [],
                requirement: []
            },
            imageShow: false,
            qrcodeUrl: ''
        };
    },
    created() {
        if (!this.$store.state.promoterId) {
            this.$router.push('/m/recommendindex');
            return;
        }
        this.getDetailByPostId(this.$route.params.id);
    },
    methods: {
        // 根据ID获取岗位详情
        async getDetailByPostId(id) {
            this.loading = true;
            const res = await api.post.getDetailByPostId(id);
            this.loading = false;
            if (res.code !== 200 || !res.data) {
                this.empty = true;
                return;
            }
            res.data.duty = res.data.duty ? res.data.duty.split(/[(\r\n)\r\n]+/) : [];
            res.data.requirement = res.data.requirement ? res.data.requirement.split(/[(\r\n)\r\n]+/) : [];
            this.post = res.data;
            this.qrcodeUrl = '/m/recommendedjob?promoterId=' + this.$store.state.promoterId + '&selected=' + res.data.postId;
        },
        // 查看更多岗位点击
        otherPostClick() {
            this.$router.go(-1);
        }
    }
};
</script>
<style lang="scss" scoped>
.main-box {
    overflow: auto;
    position: relative;
    height: 100%;
    border-top: 80px solid #00003C;
    box-sizing: border-box;
}
.main-container {
    margin-top: 30px;
    width: 1200px;
    min-width: 1200px;
    height: 100%;
    box-sizing: border-box;
    margin: auto;
}
.left-container, .right-container {
    padding: 0 8px;
    margin-top: 30px;
}
.left-container {
    .container {
        background: #fff;
        padding: 20px 30px;
    }
    .header {
        position: relative;
        margin-bottom: 16px;
        .title {
            font-size: 20px;
            line-height: 28px;
            color: #222831;
            margin-right: 120px;
            font-weight: 600;
            position: relative;
            .salary {
                position: absolute;
                color: #ff6b6b;
                font-size: 16px;
                line-height: 28px;
                right: -120px;
                top: 0;
            }
        }
        .status {
            margin-top: 15px;
            margin-right: 96px;
            color: #89909e;
            .item {
                padding: 0 10px;
                border-right: 1px solid #dddfe3;
            }
            .item:first-child {
                padding-left: 0;
            }
            .item:last-child {
                border-right: none;
            }
        }
        .btn {
            position: absolute;
            bottom: 0;
            right: 0;
        }
    }
    .content {
        .title {
            margin-bottom: 19px;
            color: #222831;
            font-size: 16px;
            position: relative;
            height: 24px;
            .describe {
                background: #fff;
                position: absolute;
                left: 0;
                z-index: 2;
                padding-right: 10px;
            }
        }
        .title::after {
            content: '';
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 50%;
            height: 1px;
            background: #f4f4f5;
        }
        .duty,.requirement {
            margin-bottom: 5px;
            font-weight: 600;
        }
        .requirement {
            margin-top: 10px;
        }
        .detailed {
            padding: 0;
            margin: 0;
        }
    }
    .footer {
        margin-top: 20px;
        text-align: center;
    }
}
</style>
<style scoped>
.container >>> .el-empty__description p{
    font-size: 24px;
}
</style>
